export default "__VITE_ASSET__BWz$0tQu__"